import { FleekError } from './FleekError';

export class MigrationRequestsAlreadyExistError extends FleekError<object> {
  public name = 'MigrationRequestsAlreadyExistError';

  toString = () => `All migration requests specified in token are either completed or in progress.`;
}
